export default __webpack_public_path__ + "img/unicorn.988a8be9.svg";